<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="campaignModal" aria-labelledby="campaignModalLabel">
    <div class="modal-dialog modal-lg">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ campaign.id ? 'Редактирование компании' : 'Новая компания' }}</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-6">
              <input-field v-model="campaign.name" id="campaign.name" name="campaign.name" placeholder="Название" type="text" mb="5" />
            </div>
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label for="campaign.status" class="required">Статус</label>
                <v-select
                  v-model="campaign.status"
                  input-id="campaign.status"
                  :options="dictStatuses"
                  :reduce="(item) => item.code"
                  label="label"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input-field v-model="campaign.priority" id="campaign.priority" name="campaign.priority" placeholder="Приоритет" type="number" mb="5" />
            </div>
            <div class="col-md-4">
              <input-field v-model="campaign.intervalDays" id="campaign.intervalDays" name="campaign.intervalDays" placeholder="Интервал в днях" type="number" mb="5" />
            </div>
            <div class="col-md-4">
              <input-field v-model="campaign.maxImpressions" id="campaign.maxImpressions" name="campaign.maxImpressions" placeholder="Макс. показы" type="number" mb="5" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field v-model="campaign.triggerEvent" id="campaign.triggerEvent" name="campaign.triggerEvent" placeholder="Событие-триггер" type="text" mb="5" />
            </div>
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label for="campaign.ruleType" class="required">Тип правила</label>
                <v-select
                  v-model="campaign.ruleType"
                  input-id="campaign.ruleType"
                  :options="dictRuleTypes"
                  :reduce="(item) => item.code"
                  label="label"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-floating mb-5">
                <input
                  id="campaign.startAt"
                  v-model="startAtInput"
                  class="form-control form-control-solid"
                  type="datetime-local"
                  autocomplete="off"
                >
                <label for="campaign.startAt">Дата начала</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating mb-5">
                <input
                  id="campaign.endAt"
                  v-model="endAtInput"
                  class="form-control form-control-solid"
                  type="datetime-local"
                  autocomplete="off"
                >
                <label for="campaign.endAt">Дата окончания</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer p-5 justify-content-between">
          <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          <button type="button" @click="saveCampaign" :disabled="saving" class="btn btn-primary btn-sm">
            {{ saving ? 'Сохранение...' : 'Сохранить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import vSelect from 'vue-select'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

const API_BASE = '/energo-inapp-messaging/api/admin/v1'

const createDefaultCampaign = () => ({
  id: null,
  name: '',
  status: null,
  priority: 0,
  triggerEvent: '',
  ruleType: null,
  intervalDays: 0,
  maxImpressions: 0,
  startAt: '',
  endAt: '',
})

export default {
  name: 'CompanyModal',
  components: { Loader, InputField, vSelect },
  props: {
    itemData: {
      type: Object,
      default: null,
    },
    dictStatuses: {
      type: Array,
      default: () => [],
    },
    dictRuleTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loaded: false,
      saving: false,
      campaign: createDefaultCampaign(),
      startAtInput: '',
      endAtInput: '',
    };
  },
  mounted() {
    this.hydrateCampaign();
    setTimeout(() => {
      const modalEl = document.getElementById('campaignModal');
      if (modalEl) {
        modalEl.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal(false);
        });
      }
    }, 10);
  },
  methods: {
    isoToDatetimeLocal(iso) {
      if (!iso) return '';
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    datetimeLocalToIso(value) {
      if (!value || String(value).trim() === '') return null;
      const d = new Date(value);
      return Number.isNaN(d.getTime()) ? null : d.toISOString();
    },
    hydrateCampaign() {
      const source = this.itemData || {};
      this.campaign = {
        ...createDefaultCampaign(),
        ...source,
      };
      this.startAtInput = this.isoToDatetimeLocal(this.campaign.startAt);
      this.endAtInput = this.isoToDatetimeLocal(this.campaign.endAt);
    },
    closeModal(isUpdate) {
      const modalInstance = bootstrap.Modal.getInstance(document.getElementById('campaignModal'));
      if (modalInstance) modalInstance.hide();
      this.$emit('closeModal', isUpdate);
    },
    saveCampaign() {
      if (!this.campaign.name || !String(this.campaign.name).trim()) {
        notify({
          duration: 7000,
          type: 'error',
          speed: 1000,
          title: 'Ошибка',
          text: 'Заполните название компании',
        });
        return;
      }
      if (this.campaign.status == null || this.campaign.status === '') {
        notify({
          duration: 7000,
          type: 'error',
          speed: 1000,
          title: 'Ошибка',
          text: 'Выберите статус',
        });
        return;
      }
      if (this.campaign.ruleType == null || this.campaign.ruleType === '') {
        notify({
          duration: 7000,
          type: 'error',
          speed: 1000,
          title: 'Ошибка',
          text: 'Выберите тип правила',
        });
        return;
      }

      this.saving = true;
      const payload = {
        id: this.campaign.id || undefined,
        name: String(this.campaign.name).trim(),
        status: this.campaign.status ?? null,
        priority: Number(this.campaign.priority || 0),
        triggerEvent: this.campaign.triggerEvent ? String(this.campaign.triggerEvent).trim() : '',
        ruleType: this.campaign.ruleType ?? null,
        intervalDays: Number(this.campaign.intervalDays || 0),
        maxImpressions: Number(this.campaign.maxImpressions || 0),
        startAt: this.datetimeLocalToIso(this.startAtInput),
        endAt: this.datetimeLocalToIso(this.endAtInput),
      };

      const request = this.campaign.id
        ? axios.put(`${API_BASE}/campaign`, payload)
        : axios.post(`${API_BASE}/campaign`, payload);

      request
        .then(() => {
          notify({
            duration: 7000,
            type: 'success',
            speed: 1000,
            title: 'Успешно',
            text: 'Компания сохранена',
          });
          this.closeModal(true);
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: err?.response?.data?.errorDescription ?? err.message,
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
}
</script>

<style scoped>

</style>
